export default __webpack_public_path__ + "files/RP3_Create_your_good_policy_in_your_region.docx";